import { createSlice } from "@reduxjs/toolkit";
import {
  CREATE_DAYOFF,
  UPDATE_DAYOFF,
  CONFIRM_DIALOG,
  DOCUMENT_DIALOG,
  START_LEAVE_DIALOG,
  EDIT_DAYOFF,
  DAYOFF_TYPE_DIALOG,
  DOCUMENT_CRUD_DIALOG,
  DAYOFF_DOCUMENT_DIALOG,
  DEPARTMENT_DIALOG,
  TEAM_DIALOG,
  CATEGORY_DIALOG,
  BRAND_DIALOG,
  MODEL_DIALOG,
  EQUIPMENT_DIALOG,
  USED_EQUIPMENT_DIALOG,
  GIVE_BACK_EQUIPMENT_DIALOG
} from "../utils/dialogEnum";

const dialogSlice = createSlice({
  name: "dialogSlice",
  initialState: {
    createDayoffOpen: false,
    updateDayoffOpen: false,
    confirmDialogOpen: false,
    documentDialogOpen: false,
    startLeaveDialogOpen: false,
    editDayoffDialogOpen: false,
    dayoffTypeDialogOpen: false,
    documentCRUDDialogOpen: false,
    dayoffDocumentDialogOpen: false,
    departmentDialogOpen: false,
    teamDialogOpen: false,
    categoryDialogOpen: false,
    brandDialogOpen: false,
    modelDialogOpen: false,
    equipmentDialogOpen: false,
    usedEquipmentDialogOpen: false,
    giveBackEquipmentDialogOpen: false,
  },
  reducers: {
    openDialog: (state, action) => {
      switch (action.payload) {
        case CREATE_DAYOFF:
          state.createDayoffOpen = true;
          break;
        case UPDATE_DAYOFF:
          state.updateDayoffOpen = true;
          break;
        case CONFIRM_DIALOG:
          state.confirmDialogOpen = true;
          break;
        case DOCUMENT_DIALOG:
          state.documentDialogOpen = true;
          break;
        case START_LEAVE_DIALOG:
          state.startLeaveDialogOpen = true;
          break;
        case EDIT_DAYOFF:
          state.editDayoffDialogOpen = true;
          break;
        case DAYOFF_TYPE_DIALOG:
          state.dayoffTypeDialogOpen = true;
          break;
        case DOCUMENT_CRUD_DIALOG:
          state.documentCRUDDialogOpen = true;
          break;
        case DAYOFF_DOCUMENT_DIALOG:
          state.dayoffDocumentDialogOpen = true;
          break;
        case DEPARTMENT_DIALOG:
          state.departmentDialogOpen = true;
          break;
        case TEAM_DIALOG:
          state.teamDialogOpen = true;
          break;
        case CATEGORY_DIALOG:
          state.categoryDialogOpen = true;
          break;
        case BRAND_DIALOG:
          state.brandDialogOpen = true;
          break;
        case MODEL_DIALOG:
          state.modelDialogOpen = true;
          break;
        case EQUIPMENT_DIALOG:
          state.equipmentDialogOpen = true;
          break;
        case USED_EQUIPMENT_DIALOG:
          state.usedEquipmentDialogOpen = true;
          break;
        case GIVE_BACK_EQUIPMENT_DIALOG:
          state.giveBackEquipmentDialogOpen = true;
          break;
        default:
          state.createDayoffOpen = false;
          state.updateDayoffOpen = false;
          state.confirmDialogOpen = false;
          state.documentDialogOpen = false;
          state.startLeaveDialogOpen = false;
          state.editDayoffDialogOpen = false;
          state.dayoffTypeDialogOpen = false;
          state.documentCRUDDialogOpen = false;
          state.dayoffDocumentDialogOpen = false;
          state.departmentDialogOpen = false;
          state.teamDialogOpen = false;
          state.categoryDialogOpen = false;
          state.brandDialogOpen = false;
          state.modelDialogOpen = false;
          state.equipmentDialogOpen = false;
          state.usedEquipmentDialogOpen = false;
          state.giveBackEquipmentDialogOpen = false;
      }
    },
    closeDialog: (state, action) => {
      switch (action.payload) {
        case CREATE_DAYOFF:
          state.createDayoffOpen = false;
          break;
        case UPDATE_DAYOFF:
          state.updateDayoffOpen = false;
          break;
        case CONFIRM_DIALOG:
          state.confirmDialogOpen = false;
          break;
        case DOCUMENT_DIALOG:
          state.documentDialogOpen = false;
          break;
        case START_LEAVE_DIALOG:
          state.startLeaveDialogOpen = false;
          break;
        case EDIT_DAYOFF:
          state.editDayoffDialogOpen = false;
          break;
        case DAYOFF_TYPE_DIALOG:
          state.dayoffTypeDialogOpen = false;
          break;
        case DOCUMENT_CRUD_DIALOG:
          state.documentCRUDDialogOpen = false;
          break;
        case DAYOFF_DOCUMENT_DIALOG:
          state.dayoffDocumentDialogOpen = false;
          break;
        case DEPARTMENT_DIALOG:
          state.departmentDialogOpen = false;
          break;
        case TEAM_DIALOG:
          state.teamDialogOpen = false;
          break;
        case CATEGORY_DIALOG:
          state.categoryDialogOpen = false;
          break;
        case BRAND_DIALOG:
          state.brandDialogOpen = false;
          break;
        case MODEL_DIALOG:
          state.modelDialogOpen = false;
          break;
        case EQUIPMENT_DIALOG:
          state.equipmentDialogOpen = false;
          break;
        case USED_EQUIPMENT_DIALOG:
          state.usedEquipmentDialogOpen = false;
          break;
        case GIVE_BACK_EQUIPMENT_DIALOG:
          state.giveBackEquipmentDialogOpen = false;
          break;
        default:
          state.createDayoffOpen = false;
          state.updateDayoffOpen = false;
          state.confirmDialogOpen = false;
          state.documentDialogOpen = false;
          state.startLeaveDialogOpen = false;
          state.editDayoffDialogOpen = false;
          state.dayoffTypeDialogOpen = false;
          state.documentCRUDDialogOpen = false;
          state.dayoffDocumentDialogOpen = false;
          state.departmentDialogOpen = false;
          state.teamDialogOpen = false;
          state.categoryDialogOpen = false;
          state.brandDialogOpen = false;
          state.modelDialogOpen = false;
          state.equipmentDialogOpen = false;
          state.usedEquipmentDialogOpen = false;
          state.giveBackEquipmentDialogOpen = false;
      }
    },
  },
});

export const { openDialog, closeDialog } = dialogSlice.actions;
export const dialogReducer = dialogSlice.reducer;
